import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
  },
  tasksContainer: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
  },
  clientTasksContainer: {
    color: theme.palette.secondary.main,
  },
  plannerTasksContainer: {
    color: theme.palette.primary.main,
  },
});

const sortTasksByGroup = options => options.reduce((acc, currentTask) => {
  const { group, ...rest } = currentTask;
  if (acc[group]) {
    acc[group].push(rest);
  } else {
    acc[group] = [rest];
  }
  return acc;
}, {});


const PlaybookPredefinedTasks = ({
  className,
  classes,
  options,
  onChange,
  value,
}) => {
  const sortedTasks = sortTasksByGroup(options);
  return (
    <div
      className={classNames(classes.root, className)}
    >
      {['Client', 'Planner'].map((category) => {
        const tasks = sortedTasks[category];
        return tasks && (
          <div className={classNames(classes.tasksContainer, {
            [classes.clientTasksContainer]: category === 'Client',
            [classes.plannerTasksContainer]: category === 'Planner',
          })}
          >
            <Typography
              variant="h2"
            >
              {category}
            </Typography>
            {tasks.map(task => (
              <FormControlLabel
                control={<Checkbox
                  onChange={() => {
                    const index = value.indexOf(task.value);
                    if (index > -1) {
                      onChange({ target: { value: value.filter(id => id !== task.value) } });
                    } else {
                      onChange({ target: { value: value.concat([task.value]) } });
                    }
                  }}
                  value={value}
                  name={task.name}
                />}
                label={task.name}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

PlaybookPredefinedTasks.defaultProps = {
  className: '',
};

PlaybookPredefinedTasks.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array.isRequired,
};

export default withStyles(styles)(PlaybookPredefinedTasks);
